import type { MixinInstances, ServiceConstructor } from "./services.types";

export function composeMixins<
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  Mixins extends readonly ((base: ServiceConstructor) => any)[]
>(...mixins: Mixins) {
  return <TBase extends ServiceConstructor>(
    Base: TBase
  ): ServiceConstructor &
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (new (...args: any[]) => InstanceType<TBase> & MixinInstances<Mixins>) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return mixins.reduce((acc, mixin) => mixin(acc), Base) as any;
  };
}
